/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowShapeARightIcon16Light } from './ArrowShapeARightIcon16Light';
import { ArrowShapeARightIcon16Regular } from './ArrowShapeARightIcon16Regular';
import { ArrowShapeARightIcon16Solid } from './ArrowShapeARightIcon16Solid';
import { ArrowShapeARightIcon20Light } from './ArrowShapeARightIcon20Light';
import { ArrowShapeARightIcon20Regular } from './ArrowShapeARightIcon20Regular';
import { ArrowShapeARightIcon20Solid } from './ArrowShapeARightIcon20Solid';
import { ArrowShapeARightIcon24Regular } from './ArrowShapeARightIcon24Regular';
import { ArrowShapeARightIcon24Solid } from './ArrowShapeARightIcon24Solid';
import { ArrowShapeARightIcon32Regular } from './ArrowShapeARightIcon32Regular';
import { ArrowShapeARightIcon64Regular } from './ArrowShapeARightIcon64Regular';
var sizes = {
    16: {
        light: ArrowShapeARightIcon16Light,
        regular: ArrowShapeARightIcon16Regular,
        solid: ArrowShapeARightIcon16Solid,
    },
    20: {
        light: ArrowShapeARightIcon20Light,
        regular: ArrowShapeARightIcon20Regular,
        solid: ArrowShapeARightIcon20Solid,
    },
    24: {
        regular: ArrowShapeARightIcon24Regular,
        solid: ArrowShapeARightIcon24Solid,
    },
    32: {
        regular: ArrowShapeARightIcon32Regular,
    },
    64: {
        regular: ArrowShapeARightIcon64Regular,
    },
};
export var ArrowShapeARightIcon = forwardRef('ArrowShapeARightIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
